import React from 'react';
import { FaArrowRight } from "react-icons/fa6";
import homeloan from '../Asserts/homeloan.png';
import personalloan from "../Asserts/personalloan.png";
import lifeinsurance from "../Asserts/lifeinsurnace.png"
import healthinsurance from "../Asserts/healthinsurnace.png";
import personalloan2 from "../Asserts/personalloan2.png";
import carloan from "../bank/carloan.png"
import indian from "../Asserts/indian.jpg"
import images from "../Asserts/images.png"
import { useNavigate } from 'react-router-dom';
import carinsurnace from "../Asserts/carinsurance copy.jpg"
import generalinsurnace from "../Asserts/generalinsurance copy.jpg"
import { Helmet } from 'react-helmet-async';

const loanData = [
  { title: "Home Loan", icon: homeloan, description: "Your Dream Home Awaits Explore the Best Home Loan Deals Compare Multiple Lenders & Interest Rates Quick Approvals with Minimal Hassle",path: "/HomeLoanPage" },
  { title: "Personal Loan", icon: personalloan2, description: "Achieve Your Dreams With Our Versatile Personal Loan Options Low Interest Rates & Quick Approvals Minimal Documentation, Maximum Convenience",path: "/PersonalLoanPage" },
  { title: "Business Loan", icon: personalloan, description: "Boost Your Business Growth With Our Flexible Financing Options Quick Approvals & Competitive Rates Tailored Solutions for Your Success",path: "/BusinessLoanPage" },
  { title: "Car loan", icon: carloan, description: "Drive Your Dream Car With Our Quick & Flexible Car Loans Low Interest Rates & Easy EMIs Fast Approvals, Hassle-Free Process" ,path: "/CarLoanPage"},
  { title: "Gold loan", icon: indian, description: "Turn Your Gold into Instant Cash With Our Quick & Secure Gold Loans Low Interest Rates & Flexible Repayment Fast Processing",path: "/GoldLoanPage"  },
  { title: "Education loan", icon: images, description: "Invest in Your Future Today With Our Easy Education Loans Low Interest Rates & Flexible EMIs Quick Approvals for a Brighter Tomorrow", path: "/EducationLoanPage"  }



];

const Insurance = [
  { title: "Life Insurance", icon: lifeinsurance, description: "Invest in Your Family's Future With Our Life Insurance Plans. Affordable Premiums, Maximum Benefits, and Peace of Mind for Tomorrow and Peace of Mind for Tomorrow",path: "/LifeInsurance"  },
  { title: "Health Insurance", icon: healthinsurance, description: "Secure Your Health, Secure Your Future With Our Comprehensive Health Insurance Plans Affordable Premiums & Extensive Coverage Quick Approvals for Peace of Mind",path: "/HealthInsurance" },
  { title: "General Insurance", icon: generalinsurnace, description: "Protect What Matters Most With Our Reliable General Insurance Plans Comprehensive Coverage & Affordable Premiums Quick Claims & Hassle-Free Process" ,path: "/Genralinsurance"},
  { title: "Car Insurance", icon: carinsurnace, description: "Drive with Confidence With Our Hassle-Free Car Insurance Plans Affordable Premiums & Comprehensive Coverage Quick Claims & Reliable Support", path: "/carinsurance" },

];

function Services() {

  const navigate = useNavigate();
  

  return (
    <div className='bg-white min-h-[300px] flex flex-col md:flex-col  justify-between px-6 md:px-20 py-10'>
      <Helmet>
        <title>Services | KOTA HOLDINGS</title>
        <meta name="description" content="Kota Holdings provides hassle-free loan and insurance services. Get home loans, personal loans, car loans, and more with quick approvals and minimal documentation." />
        <meta name="keywords" content="Kota Holdings, Home Loan, Personal Loan, Car Loan, Gold Loan, Business Loan, Health Insurance, Life Insurance, Vehicle Insurance" />
        <meta name="author" content="Kota Holdings" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Get Loans & Insurance Easily" />
        <meta property="og:description" content="Kota Holdings offers personalized loan and insurance solutions, including home loans, car loans, business loans, and general insurance, with expert guidance." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://yourwebsite.com/services" />
        <meta property="og:image" content="https://yourwebsite.com/path-to-image.jpg" />
      </Helmet>
      
      <div className="container mx-auto px-4 py-8">
      {/* Loan Assistance Section */}
      <h1 className="text-left p-5 text-[#FF6F00] font-bold text-3xl md:text-4xl">
        Loan Assistance
      </h1>
      <p className="text-gray-700 px-6 py-3">
        Wide Range of Financial Products That Suit Your Customer's Needs!
      </p>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 p-3">
        {loanData.map((loan, index) => (
          <div
            key={index}
            className="rounded-lg p-6 w-full bg-[#F8F9FA] shadow-md hover:shadow-lg transition duration-300"
          >
            <div className="flex flex-col  text-left">
              <img src={loan.icon} alt={loan.title} className="w-16 h-16" />
              <h3 className="text-2xl font-semibold mt-3">{loan.title}</h3>
            </div>
            <p className="text-[#808080] mt-2 text-left">{loan.description}</p>
            <button
              onClick={() => navigate(loanData.path)}
              className="mt-4 w-full text-white bg-[#FF6F00] py-2 rounded-md flex justify-center items-center gap-2"
            >
              Apply Now <FaArrowRight />
            </button>
          </div>
        ))}
      </div>

      {/* Insurance Solutions Section */}
     {/* Insurance Solutions Section */}
<h1 className="text-left p-5 text-[#FF6F00] font-bold text-3xl md:text-4xl mt-10">
  Insurance Solutions
</h1>
<p className="text-gray-700 px-6 py-3">Wide Range of Insurance Products</p>

<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 p-3">
  {Insurance.map((insurance, index) => (
    <div
      key={index}
      className="rounded-lg p-6 w-full bg-[#F8F9FA] shadow-md hover:shadow-lg transition duration-300 min-h-[350px] flex flex-col justify-between"
    >
      <div>
        <div className="flex flex-col">
          <img src={insurance.icon} alt={insurance.title} className="w-16 h-16" />
          <h3 className="text-2xl font-semibold mt-3">{insurance.title}</h3>
        </div>
        <p className="text-[#808080] mt-2">{insurance.description}</p>
      </div>
      
      <button
        onClick={() => navigate(insurance.path)}
        className="mt-4 w-full text-white bg-[#FF6F00] py-2 rounded-md flex justify-center items-center gap-2"
      >
        Apply Now <FaArrowRight />
      </button>
    </div>
  ))}
</div>

    </div>
      <div className="text-left px-4 md:px-1 py-8">
  <h1 className="text-2xl md:text-4xl font-bold text-[#FF6F00]">
  Why We Are Better Than Others
  </h1>
  <p className="text-gray-600 text-sm md:text-lg mt-4  p-2">
    Experience seamless financial solutions with Kota Holdings. We provide expert guidance, multiple bank comparisons, and hassle-free processing to ensure you get the best deals with minimal effort.
  </p>

  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 mt-6">
    <div className="p-4 bg-white shadow-lg rounded-lg">
      <h2 className="text-lg font-semibold text-gray-700">✔ Multiple Bank Comparisons</h2>
      <p className="text-sm text-gray-500">
        Get the best deals by comparing various banks and financial institutions, ensuring the most competitive rates.
      </p>
    </div>

    <div className="p-4 bg-white shadow-lg rounded-lg">
      <h2 className="text-lg font-semibold text-gray-700">✔ Expert Guidance</h2>
      <p className="text-sm text-gray-500">
        Our financial professionals help you select the right loan or insurance policy based on your needs.
      </p>
    </div>

    <div className="p-4 bg-white shadow-lg rounded-lg">
      <h2 className="text-lg font-semibold text-gray-700">✔ Quick & Hassle-Free Processing</h2>
      <p className="text-sm text-gray-500">
        We manage all the paperwork and approvals, making the process seamless for you.
      </p>
    </div>

    <div className="p-4 bg-white shadow-lg rounded-lg">
      <h2 className="text-lg font-semibold text-gray-700">✔ Minimal Documentation</h2>
      <p className="text-sm text-gray-500">
        Enjoy easy eligibility and simple documentation requirements for faster approvals.
      </p>
    </div>
  </div>
      </div>
      <div className="text-left px-4 md:px-1 py-8">
  <h1 className="text-2xl md:text-4xl font-bold text-[#FF6F00]">
    How It Works
  </h1>
  <p className="text-gray-600 text-sm md:text-lg mt-4 ">
    Our simple and transparent process ensures you get the best loan or insurance plan with ease.
  </p>

  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
    <div className="p-4 bg-white shadow-lg rounded-lg flex flex-col items-center  md:text-center">
      <h2 className="text-lg font-semibold text-gray-700">📌 Submit Your Details</h2>
      <p className="text-sm text-gray-500 mt-2">
        Tell us your loan or insurance requirements, and we’ll find the best options for you.
      </p>
    </div>

    <div className="p-4 bg-white shadow-lg rounded-lg flex flex-col items-center md:text-center">
      <h2 className="text-lg font-semibold text-gray-700">🔍 Compare Options</h2>
      <p className="text-sm text-gray-500 mt-2">
        We provide the best offers from leading banks and financial institutions.
      </p>
    </div>

    <div className="p-4 bg-white shadow-lg rounded-lg flex flex-col items-center md:text-center">
      <h2 className="text-lg font-semibold text-gray-700">✅ Choose the Best Plan</h2>
      <p className="text-sm text-gray-500 mt-2">
        Select the loan or insurance plan that best suits your financial needs.
      </p>
    </div>

    <div className="p-4 bg-white shadow-lg rounded-lg flex flex-col items-center md:text-center">
      <h2 className="text-lg font-semibold text-gray-700">🚀 Get Approved</h2>
      <p className="text-sm text-gray-500 mt-2">
        We assist with documentation and approval to ensure a smooth process.
      </p>
    </div>
  </div>
</div>
    </div>
  );
}

export default Services;
